var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.contenthtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }